import { api } from '@/lib/api/client';
import type { ActivityResource, ActivityResourceType } from './activityTypes';

/** Resources per page in the Profile activity tabs. */
export const ACTIVITY_PER_PAGE = 12;

/**
 * Reads the logged-in user's write-activity history. `type` rides as a plain
 * query param alongside the `range` pagination tuple `buildListParams` emits.
 */
export const profileActivityApi = {
  list: (
    type: ActivityResourceType,
    page: number,
    perPage = ACTIVITY_PER_PAGE,
  ) =>
    api.list<ActivityResource>(
      '/profile/activity',
      { page, perPage },
      { params: { type } },
    ),
};
